//
import HrContractStructureModel from '@/models/HumanResource/HrContractStructure'

/**
 * This class describes a hr contract structure.
 * 
 * @class HrContractStructure (name)
 */
export default class HrContractStructure extends HrContractStructureModel {

  static toList() {
    //
    this.includes = [
      'hr_contract_period',
      'hr_contract_type',
    ]
    //
    return this
  }
}